
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Ja, das UV-Licht der Sonne ist sehr effektiv bei der Deaktivierung des Virus,
  insbesondere bei hoher Intensität. Zum Beispiel sinkt die Lebensdauer des
  Virus von ungefähr 1 Stunde (bei 21°C und 40% relativer Luftfeuchtigkeit) ohne
  Einstrahlung auf 10 Minuten bei einem UV-Index von 2 und auf rund 2 Minuten
  bei voller Sonneneinstrahlung (UV-Index 10). Viren auf Oberflächen können so
  draussen im Laufe des Tages schnell deaktiviert werden. Für die Aerosol- oder
  Tröpfchen-Übertragung im Freien spielt das weniger eine Rolle. Ausgestossene
  Tröpfchen erreichen ihre Ziele (Augen, Nasenlöcher, Mund) in ungefähr 1
  Sekunde. Aerosole verflüchtigen sich bei normalen Windgeschwindigkeiten im
  Freien, sofern sie nicht innerhalb weniger Sekunden eingeatmet wurden.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;